import styled from 'styled-components';
import { spacing } from 'ui/theme/utils';

export const CategoryLabel = styled.label`
  text-align: left;
  font-weight: normal;
  font-size: 13px;
  letter-spacing: 0.62px;
  color: #333;
  word-break: break-word;
  ${(props) => spacing(props)}
`;
